import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Modal, Button, Form } from "react-bootstrap";
import MainHeader from "../../Pages/Header/MainHeader";
import FooterStyle from "../Footer/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import API from '../../Api/Api';
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { IMAGE_PATHS, base64Encode, base64Decode, DOMAIN_URL, formatExperienceDate, toCustomCamelCase } from "../../Functions/Constant";
import Loader from "../../Components/Loader";
import ButtonsVariant from '../../Components/Button/ButtonVariant'; // Fixed: Use default import



const SearchForm = () => {
    const location = useLocation();
    const [users, setUsers] = useState([]);
    const [visibleItems, setVisibleItems] = useState(5);
    const [queryString, setQueryString] = useState({});
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const navigate = useNavigate();
    const loaderRef = useRef(null);
    const [focusedField, setFocusedField] = useState(null);
    const [showViewAllModal, setShowViewAllModal] = useState(false); // New state for View All modal
    const [selectedUser, setSelectedUser] = useState(null);
    const [jwtTokenJobcritic, setjwtTokenJobcritic] = useState(localStorage.getItem("jwt_token_jobcritic"));
    const [filters, setFilters] = useState({
        name: "",
        company: "",
        school: "",
        location: "",
        phone: "",
    });
    const [inputFilters, setInputFilters] = useState({
        name: "",
        company: "",
        school: "",
        location: "",
        phone: "",
    });

    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isFetching, setIsFetching] = useState(false); // To prevent duplicate fetches


    const validationSchema = Yup.object().shape({
        name: Yup.string()
            .required("Name is required")
            .matches(/^[a-zA-Z\s'-]+$/, "Name can only contain letters, spaces, hyphens, or apostrophes"),
        workType: Yup.string()
            .required("Type is required")
            .oneOf(["1", "2"], "Invalid type selected"),
        companyOrStudyWork: Yup.string().when("workType", {
            is: "1",
            then: (schema) => schema.required("Company is required"),
            otherwise: (schema) => schema.notRequired(),
        }),
        school: Yup.string().when("workType", {
            is: "2",
            then: (schema) =>
                schema
                    .required("University/Institution Name is required")
                    .test(
                        "wordCount",
                        "School name must be at most 10 words",
                        (value) => (value ? value.trim().split(/\s+/).length <= 10 : true)
                    ),
            otherwise: (schema) => schema.notRequired(),
        }),
        location: Yup.string().required("Location is required"),
        email: Yup.string()
            .email("Invalid email address")
            .required("Email is required"), // Email validation
    });

    const getQueryParams = () => {
        const searchParams = new URLSearchParams(location.search);
        return searchParams;
    };
    // const fetchUsers = async (reset = false) => {
    //     if (isFetching || (page > totalPages && !reset)) return;
    //     setIsFetching(true);
    //     setLoading(true);
    //     try {
    //         const payload = {
    //             name: filters.name,
    //             company: filters.company,
    //             school: filters.school,
    //             location: filters.location,
    //             phone: filters.phone,
    //             page: reset ? 1 : page,
    //             limit: 10,
    //             sortBy: "name",
    //         };
    //         const response = await API.post('/userSearch/search-user', payload);
    //         if (response.success) {
    //             setUsers((prev) => reset ? response.users : [...prev, ...response.users]); // Append or reset users
    //             setTotalPages(response.pagination.totalPages);
    //             if (!reset) setPage((prev) => prev + 1); // Increment page only if not resetting
    //         } else if (response.message === "oops! No matches found") {
    //             setUsers([]);
    //             setTotalPages(1)
    //         }
    //     } catch (error) {
    //         console.error("Error fetching users:", error);
    //     } finally {
    //         setLoading(false);
    //         setIsFetching(false);
    //     }
    // };
    const fetchUsers = async (reset = false) => {
        if (isFetching || (page > totalPages && !reset)) return;
        setIsFetching(true);
        setLoading(true);
        try {
            const payload = {
                name: filters.name,
                company: filters.company,
                school: filters.school,
                location: filters.location,
                phone: filters.phone,
                page: reset ? 1 : page,
                limit: 10,
                sortBy: "name",
            };
            const response = await API.post('/userSearch/search-user', payload);
            if (response.success) {
                setUsers((prev) => {
                    const newUsers = reset ? response.users : [...prev, ...response.users];
                    return newUsers;
                });
                setTotalPages(response.pagination.totalPages);
            } else if (response.message === "oops! No matches found") {
                setUsers([]);
                setTotalPages(1);
            }
        } catch (error) {
            console.error("Error fetching users:", error);
        } finally {
            setLoading(false);
            setIsFetching(false);
        }
    };


    const fetcFirstTimeUsers = async (payload) => {
        setLoading(true);
        try {
            const response = await API.post('/userSearch/search-user', payload);
            if (response.success) {
                setUsers(response.users);
                setTotalPages(response.pagination.totalPages);
                setPage(1);
            } else if (response.message === "oops! No matches found") {
                setUsers([]);
                setTotalPages(1);
            }
        } catch (error) {
            console.error("Error fetching users:", error);
        } finally {
            setLoading(false);
        }
    };

    const rateNow = async (user) => {

        const payload = {
            user_id: user.user_id,
            type: user.data_type,
            tag_data_id: user.w_id,
        };
        try {
            const response = await API.post('/user/initiate-rating', payload);
            window.location.href = '/review/' + base64Encode(response.review_id);
        } catch (error) {
            console.error("Error initiating rating:", error);
        }
    };


    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setInputFilters((prev) => ({
            ...prev,
            [name]: value,
        }));
    };
    const handleFilterSubmit = (e) => {
        const { name, value } = e.target;
        if (name === "name") {
            navigate(`/search?query=${encodeURIComponent(value)}`);
            //return;
        }
        setFilters((prev) => ({
            ...prev,
            [name]: value,
        }));
        setPage(1); // Reset page to 1 on filter change
        setUsers([]); // Clear users to avoid stale data
    };

    // const filteredUsers = users.filter((user) => {
    //     return (
    //         user.name.toLowerCase().includes(filters.name.toLowerCase()) &&
    //         user.company_name.toLowerCase().includes(filters.company.toLowerCase()) &&
    //         user.school_name.toLowerCase().includes(filters.school.toLowerCase()) &&
    //         user.city_name.toLowerCase().includes(filters.location.toLowerCase())
    //     );
    // });

    const handleReviewSubmission = () => {
        setShowModal(true);
    };

    const handleClose = () => {
        setShowModal(false);
    };

    // const handleSubmitReview = (values) => {
    //     console.log("Review submitted:", values);
    //     // Add API call or storage logic here to save reviewData
    //     handleClose();
    //     // For now, redirect to review form (optional)
    //     // window.location.href = '/review_form';
    // };

    const handleSubmitReview = async (values) => {
        //setSubmitting(true);
        //setApiError(null);
        try {
            const payload = {
                name: values.name,
                city: values.location,
                search_type: values.workType,
                company: values.workType === "1" ? values.companyOrStudyWork : "",
                school: values.workType === "2" ? values.school : "",
                email: values.email,
            };

            const response = await API.post('/userSearch/usercreate-for-rating', payload);
            if (response.message === "User created successfully") {
                handleClose();
                window.location.href = '/review/' + base64Encode(response.review_id);
            } else {
                //setApiError(response.message || "Failed to create user");
            }
        } catch (error) {
            console.error("Error creating user:", error);
            // setApiError(error.response?.data?.message || "Something went wrong");
        } finally {
            /// setSubmitting(false);
        }
    };
    useEffect(() => {
        setPage(1);
        fetchUsers(true);
    }, [filters]);

    useEffect(() => {
        if (page > 1) {
            fetchUsers();
        }
    }, [page]);
    // useEffect(() => {
    //     //setUsers(dummyData);
    //     const searchParams = getQueryParams();
    //     setQueryString(searchParams);
    //     setFilters((prev) => ({
    //         ...prev,
    //         'name': searchParams,
    //     }));
    //     fetcFirstTimeUsers(searchParams);
    //     console.log(searchParams);
    // }, []);

    useEffect(() => {
        if (jwtTokenJobcritic) {
            const searchParams = getQueryParams();
            const value = searchParams.get("query");
            const type = searchParams.get("category");
            setQueryString(value);
            if (type == "name") {
                setFilters((prev) => ({
                    ...prev,
                    name: value,
                }));
                setInputFilters((prev) => ({
                    ...prev,
                    name: value,
                }));
            } else if (type == "company") {
                setFilters((prev) => ({
                    ...prev,
                    company: value,
                }));
                setInputFilters((prev) => ({
                    ...prev,
                    company: value,
                }));
            } else if (type == "school") {
                setFilters((prev) => ({
                    ...prev,
                    school: value,
                }));
                setInputFilters((prev) => ({
                    ...prev,
                    school: value,
                }));
            } else if (type == "location") {
                setFilters((prev) => ({
                    ...prev,
                    location: value,
                }));
                setInputFilters((prev) => ({
                    ...prev,
                    location: value,
                }));
            } else if (type == "contact") {
                setFilters((prev) => ({
                    ...prev,
                    phone: value,
                }));
                setInputFilters((prev) => ({
                    ...prev,
                    phone: value,
                }));
            }
            const payload = {
                name: type === "name" ? value : filters.name,
                company: type === "company" ? value : filters.company,
                school: type === "school" ? value : filters.school,
                location: type === "location" ? value : filters.location,
                phone: type === "contact" ? value : filters.phone,
                page: 1,
                limit: 10,
                sortBy: "name",
            };
            fetcFirstTimeUsers(payload);
        } else {
            const searchParams = getQueryParams();
            const value = searchParams.get("query");
            const type = searchParams.get("category");;
            localStorage.setItem("redirectPath_jobcritic", window.location.pathname + '?query=' + value + '&category=' + type);
            navigate("/login");
        }

    }, [location.search]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && page < totalPages && !loading && !isFetching) {
                    setPage((prev) => prev + 1);
                }
            },
            {
                root: null,
                rootMargin: '100px',
                threshold: 0.1,
            }
        );

        if (loaderRef.current) {
            observer.observe(loaderRef.current);
        }

        return () => {
            if (loaderRef.current) {
                observer.unobserve(loaderRef.current);
            }
        };
    }, [page, totalPages, loading, isFetching]);
    // Handler for View All button click
    const [selectedEntry, setSelectedEntry] = useState(null);

    // Handler for View All button click (modified to select first entry by default)
    const handleViewAllClick = (user) => {
        setSelectedUser(groupedUsers[user.user_id]); // Use groupedUsers to get all entries
        setSelectedEntry(null); // No default selection
        setShowViewAllModal(true);
    };

    // Handler to close View All modal
    const handleViewAllClose = () => {
        setShowViewAllModal(false);
        setSelectedUser(null);
        setSelectedEntry(null); // Reset selected entry
    };
    const groupedUsers = users.reduce((acc, user) => {
        if (!acc[user.user_id]) {
            acc[user.user_id] = {
                user_id: user.user_id,
                name: user.name,
                profile_picture: user.profile_picture,
                city_name: user.city_name,
                profile_title: user.profile_title,
                entries: [],
            };
        }
        // Spread user.experiences_education with user_id added to each experience
        if (user.experiences_education && user.experiences_education.length > 0) {
            const experiencesWithUserId = user.experiences_education.map(experience => ({
                ...experience,
                user_id: user.user_id
            }));
            acc[user.user_id].entries.push(...experiencesWithUserId);
        }
        return acc;
    }, {});

    // Convert grouped users to an array for rendering
    const groupedUserList = Object.values(groupedUsers);

    const UserCard = ({ user, showButtons = true, showViewAll = false, showReviewNow = true }) => {
    return (
        <Row className="p-6 bg-white mb-[15px] rounded-lg border-1">
            <Col lg={8} md={8} sm={8}>
                <div className="flex">
                    <img
                    crossorigin="anonymous"
                        src={DOMAIN_URL + user.profile_picture || IMAGE_PATHS.USER}
                        className="w-[80px] h-[80px] rounded-full object-cover border border-gray-300"
                        alt={`${user.name}'s profile`}
                    />
                    <div className="flex flex-col justify-center ml-4">
                        <h4 className="text-lg font-bold text-gray-900 mb-0">
                           {toCustomCamelCase(user.name)}
                        </h4>
                        <p className="font-bold text-gray-600 leading-[1.6]">{user.profile_title}</p>
                        
                        <p className="text-gray-700 leading-[1.5]">{user.city_name}</p>
                    </div>
                </div>
            </Col>
            {showButtons && (
                <Col lg={4} md={4} sm={4} className="flex justify-end items-center">
                    {showReviewNow && !showViewAll && (
                        <ButtonsVariant
                            ariaLabel="button"
                            onClick={() => rateNow(user)}
                            href="#"
                            className="mx-[10px]"
                            variant="whiteToBlack"
                            size="xs"
                            title="Review Now"
                        />
                    )}
                    {showViewAll && (
                        <ButtonsVariant
                            ariaLabel="button"
                            onClick={() => handleViewAllClick(user)}
                            href="#"
                            className="mx-[10px]"
                            variant="whiteToBlack"
                            size="xs"
                            title="Review Now"
                        />
                    )}
                </Col>
            )}
        </Row>
    );
};

    // Updated UserCardPop Component with selection and new className
    const UserCardPop = ({ user, showButtons = true, showViewAll = false, showReviewNow = true, isSelected, onSelect }) => (
        <Row
            className={`p-2 bg-white mb-[15px] rounded-lg border-1 hover:border-black ${isSelected ? 'hov-ck' : 'border-gray-300'
                }`}
            onClick={() => onSelect(user)} // Make the card clickable to select
            style={{ cursor: 'pointer' }}
        >
            <Col lg={8} md={8} sm={8}>
                <div className="flex">
                    <img
                    crossorigin="anonymous"
                        src={user.data_type == 1 ? IMAGE_PATHS.BUILDING : IMAGE_PATHS.SCHOOL}
                        className="w-[50px] h-[50px] rounded-full object-cover border border-gray-300"
                        alt={`${user.name}'s profile`}
                    />
                    <div className="flex flex-col justify-center ml-4">
                        {user.w_name && (
                            <>
                                <p className="font-bold text-gray-600 leading-[1.6]">{toCustomCamelCase(user.w_name)}</p>
                            </>
                        )}
                        <p className="text-gray-700">{user.city_name}</p>
                    </div>
                </div>
            </Col>
        </Row>
    );
    return (
        <div style={{ "--base-color": "#374162" }}>
            <MainHeader />
            <section className="pb-[60px] px-4 pt-[120px] sm:pb-[60px] sm:pt-[60px] md:pb-[60px] md:pt-[60px] custm-bg">
                <Container>
                    <Row className="relative">
                        {/* Sidebar for Filters */}
                        <Col lg={3} md={12} sm={12} className="mb-4 sm:p-0 md:p-0">
                            <div className="sticky top-[28px]">
                                <h3 className="text-[26px] font-bold text-black mb-2 leading-[1.5]">
                                    Search Results
                                </h3>
                                <div className="p-4 border rounded-lg bg-white">

                                    <h4 className="text-lg font-bold mb-4 text-black mt-[20px]">Filters</h4>
                                    {["name", "phone", "company", "school", "location"].map((field) => {
                                        const isCompanyDisabled =
                                            field === "company" &&
                                            (focusedField === "school" ||
                                                filters.school.trim() !== "" ||
                                                inputFilters.school.trim() !== "");
                                        const isSchoolDisabled =
                                            field === "school" &&
                                            (focusedField === "company" ||
                                                filters.company.trim() !== "" ||
                                                inputFilters.company.trim() !== "");

                                        const placeholderMap = {
                                            name: "Search by name",
                                            phone: "Search by phone/email",
                                            company: "Search by company",
                                            school: "Search by school/college",
                                            location: "Search by location",
                                        };

                                        return (
                                            <div className="mb-3" key={field}>
                                                <label className="block text-[15px] font-semibold text-gray-600">
                                                    {field === "school"
                                                        ? "School/College"
                                                        : field === "phone"
                                                            ? "Contact"
                                                            : field.charAt(0).toUpperCase() + field.slice(1)}
                                                </label>
                                                {filters[field].trim() !== "" ? (
                                                    <div className="flex items-baseline justify-between px-3 py-2 border border-gray-300 rounded-md bg-gray-100">
                                                        <span className="text-sm text-gray-800 truncate">{filters[field]}</span>
                                                        <button
                                                            type="button"
                                                            onClick={() => {
                                                                if (field === "company" || field === "school") {
                                                                    // Clear both company and school fields and reset focus
                                                                    setFilters((prev) => ({
                                                                        ...prev,
                                                                        company: "",
                                                                        school: "",
                                                                    }));
                                                                    setInputFilters((prev) => ({
                                                                        ...prev,
                                                                        company: "",
                                                                        school: "",
                                                                    }));
                                                                    setFocusedField(null); // Reset focus to ensure no field is disabled
                                                                } else {
                                                                    // Clear only the specific field for other fields
                                                                    setFilters((prev) => ({
                                                                        ...prev,
                                                                        [field]: "",
                                                                    }));
                                                                    setInputFilters((prev) => ({
                                                                        ...prev,
                                                                        [field]: "",
                                                                    }));
                                                                }
                                                                setPage(1);
                                                            }}
                                                            className="ml-2 text-gray-500 hover:text-red-500 text-sm font-bold"
                                                        >
                                                            ✕
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <input
                                                        type={field === "phone" ? "tel" : "text"}
                                                        name={field}
                                                        value={inputFilters[field]}
                                                        onChange={handleFilterChange}
                                                        onFocus={() => setFocusedField(field)}
                                                        onBlur={() => setFocusedField(null)}
                                                        className="form-control fomc-cls px-3 py-2 w-full appearance-none border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                        placeholder={placeholderMap[field]}
                                                        disabled={isCompanyDisabled || isSchoolDisabled}
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                handleFilterSubmit({ target: { name: field, value: inputFilters[field] } });
                                                            }
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </Col>


                        {/* Search Results */}
                        <Col lg={9} md={12} sm={12} className="pt-[46px] sm:pt-[0px] md:pt-[0px]">
                            {/* <h3 className="text-[32px] font-bold text-black mb-10 leading-[1.5]">
                                {users.length} results matching
                            </h3> */}

                            {/* No Matches Content (shown when no results) */}
                            {users.length === 0 && (
                                <div className="p-6  text-center">

                                    <img
                                    crossorigin="anonymous"
                                        src={IMAGE_PATHS.RateForm}
                                        alt="No matches"
                                        className="mx-auto mb-2  object-cover rounded"
                                        width="300px"
                                    />
                                    <p className="text-gray-400 mb-2 font-extrabold text-lg">No Match Found</p>
                                    <p className="text-black text-[22px] font-extrabold mb-2">But don’t worry — you can still leave a review!</p>
                                    <p className="text-bold text-gray-900 mb-3 text-[20px]">
                                        Simply enter the person’s details. As soon as we find a match on our platform, we’ll automatically link your review to their profile.
                                    </p>
                                    {/* <button
                                        onClick={handleReviewSubmission}
                                        className="btn-explore-white px-4 py-2 rounded-md text-sm"
                                    >
                                        Search to review
                                    </button> */}
                                    <ButtonsVariant
                                        ariaLabel="button"
                                        onClick={handleReviewSubmission}
                                        href="#"
                                        className="mx-[10px]"
                                        variant="whiteToBlack"
                                        size="xs"
                                        title="Review Now"
                                    />
                                </div>
                            )}

                            {groupedUserList.map((group, index) => (
                                <UserCard
                                    key={index}
                                    user={{
                                        ...group,
                                        // Use the first entry's data for display in the main list
                                        w_name: group.entries[0].w_name,
                                        w_id: group.entries[0].w_id,
                                        start_month: group.entries[0].start_month,
                                        start_year: group.entries[0].start_year,
                                        end_month: group.entries[0].end_month,
                                        end_year: group.entries[0].end_year,
                                        data_type: group.entries[0].data_type,
                                    }}
                                    showViewAll={group.entries.length > 1} // Show "View All" if multiple entries
                                    showReviewNow={group.entries.length === 1} // Show "Review Now" only if single entry
                                />
                            ))}

                            {loading && (
                                <div className="text-center mt-4">
                                    <Loader />
                                </div>
                            )}

                            {!loading && page < totalPages && (
                                <div
                                    ref={loaderRef}
                                    className="h-10"
                                    aria-hidden="true"
                                />
                            )}
                        </Col>
                    </Row>
                </Container>
            </section>
            <Modal show={showViewAllModal} onHide={handleViewAllClose} centered backdrop="static" keyboard={false} className="zl">
                <Modal.Header closeButton className="p-4 hed">
                    <Modal.Title className="text-lg font-bold text-gray-900">Select Where You Worked or Studied Together?</Modal.Title>
                </Modal.Header>
                <h6 className="text-lg font-bold mb-2 text-gray-500s p-[24px] pt-[25px] pb-[4px] !text-[16px]">
                    We’ll add your review to the selected company or institution.
                </h6>
                <div className="p-[35px] pb-[20px] pt-[0px]">
                    {selectedUser &&
                        selectedUser.entries.map((entry, index) => (
                            <UserCardPop
                                key={index}
                                user={entry}
                                showButtons={false} // No buttons in card
                                showViewAll={false}
                                showReviewNow={false}
                                isSelected={selectedEntry && selectedEntry.w_id === entry.w_id && selectedEntry.data_type === entry.data_type} // Compare by w_id
                                onSelect={(entry) => setSelectedEntry(entry)} // Set selected entry
                            />
                        ))}
                </div>
                <div className="bg-white p-4 border-t border-gray-300 flex rounded-b-lg justify-end">
                    <ButtonsVariant
                        ariaLabel="button"
                        onClick={() => selectedEntry && rateNow(selectedEntry)} // Pass selected entry to rateNow
                        href="#"
                        className={`mx-[10px] ${!selectedEntry ? '!bg-gray-400 text-black !cursor-not-allowed !border-gray-300' : ''}`} // Gray styling when disabled
                        variant={`${!selectedEntry ? '' : 'whiteToBlack'}`}
                        size="xs"
                        title="Continue"
                        disabled={!selectedEntry} // Disable if no entry is selected
                    />
                </div>
            </Modal>

            <Modal show={showModal} onHide={handleClose} centered backdrop="static" keyboard={false} className="zl">
                <Modal.Header closeButton className="p-4 hed">
                    <Modal.Title className="text-lg font-bold text-gray-900">Submit Review</Modal.Title>
                </Modal.Header>
                <Formik
                    initialValues={{
                        name: "",
                        workType: "",
                        companyOrStudyWork: "",
                        school: "",
                        location: "",
                        email: "",
                    }}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmitReview} // Use handleSubmitReview as the onSubmit handler
                >
                    {({ isSubmitting, values, handleSubmit }) => ( // Use Formik's handleSubmit
                        <Form onSubmit={handleSubmit}> {/* Bind Formik's handleSubmit */}
                            <div className="relative p-[28px]  pb-0">
                                {/* Name */}
                                <Form.Group className="mb-3 leading-[1.5]">
                                    <Form.Label className="mb-0 text-g">Name *</Form.Label>
                                    <Field
                                        name="name"
                                        type="text"
                                        className="form-control fomc-cls"
                                        placeholder="Enter name"
                                    />
                                    <ErrorMessage name="name" component="div" className="text-danger text-sm" />
                                </Form.Group>

                                {/* Email */}
                                <Form.Group className="mb-3 leading-[1.5]">
                                    <Form.Label className="mb-0 text-g">Email *</Form.Label>
                                    <Field
                                        name="email"
                                        type="email"
                                        className="form-control fomc-cls"
                                        placeholder="Enter email"
                                    />
                                    <ErrorMessage name="email" component="div" className="text-danger text-sm" />
                                </Form.Group>

                                {/* Type */}
                                <Form.Group className="mb-3 leading-[1.5]">
                                    <Form.Label className="mb-0 text-g">Type *</Form.Label>
                                    <Field as="select" name="workType" className="form-select fomc-cls">
                                        <option value="" disabled>
                                            Select Type
                                        </option>
                                        <option value="1">Work</option>
                                        <option value="2">Study</option>
                                    </Field>
                                    <ErrorMessage name="workType" component="div" className="text-danger text-sm" />
                                </Form.Group>

                                {/* Company */}
                                <Form.Group className="mb-3 leading-[1.5]">
                                    <Form.Label className="mb-0 text-g">Company {values.workType === "1" && "*"}</Form.Label>
                                    <Field
                                        name="companyOrStudyWork"
                                        type="text"
                                        className="form-control fomc-cls"
                                        placeholder="Enter company"
                                        disabled={values.workType === "2"}
                                    />
                                    <ErrorMessage
                                        name="companyOrStudyWork"
                                        component="div"
                                        className="text-danger text-sm"
                                    />
                                </Form.Group>

                                {/* School */}
                                <Form.Group className="mb-3 leading-[1.5]">
                                    <Form.Label className="mb-0 text-g">School {values.workType === "2" && "*"}</Form.Label>
                                    <Field
                                        name="school"
                                        type="text"
                                        className="form-control fomc-cls"
                                        placeholder="Enter school"
                                        disabled={values.workType === "1"}
                                    />
                                    <ErrorMessage name="school" component="div" className="text-danger text-sm" />
                                </Form.Group>

                                {/* Location */}
                                <Form.Group className="mb-[108px] leading-[1.5]">
                                    <Form.Label className="mb-0 text-g">Location *</Form.Label>
                                    <Field
                                        name="location"
                                        type="text"
                                        className="form-control fomc-cls"
                                        placeholder="Enter location"
                                    />
                                    <ErrorMessage name="location" component="div" className="text-danger text-sm" />
                                </Form.Group>
                            </div>
                            <div className="absolute bottom-0 left-0 w-full bg-white p-4 border-t border-gray-300 flex rounded-b-lg justify-end">

                                {/* <ButtonsVariant
                                    ariaLabel="submit-button"
                                    type="submit"
                                    className="mx-[10px] btna"
                                    variant="whiteToBlack"
                                    size="xs"
                                    title="Review Now"
                                    disabled={isSubmitting}
                                /> */}
                                <Button
                                    type="submit"
                                    className="btn-explore-white"
                                    disabled={isSubmitting}
                                    size="xs"
                                >
                                    {isSubmitting ? "Submitting..." : "Review Now"}
                                </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal>


            <FooterStyle theme="light" className="bg-black text-[#828282]" />
        </div>
    );
};

export default SearchForm;